import {ValueObject} from '@s-ui/domain'

export class EmptyResponseDraftValueObject extends ValueObject {}
